function sortKeys(data) {
  return Object.fromEntries(
    [...Object.entries(data)].sort((a, b) => a[0] < b[0] ? -1 : 1)
  );
}

export { sortKeys };
//# sourceMappingURL=util.esm.js.map
